import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-screen grid md:grid-cols-2" data-testid="login-page">
      <div className="hidden md:block bg-[#F3EFEA] relative">
        <img
          src="https://images.pexels.com/photos/28405815/pexels-photo-28405815.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=900"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col justify-center px-6 md:px-16 py-16">
        <Link to="/" className="font-serif text-xl tracking-[0.3em] text-[#1A1A1A] mb-16">DABKAZARI</Link>
        <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Sign in</p>
        <h1 className="font-serif text-4xl md:text-5xl mt-3">Welcome back.</h1>

        <button
          onClick={googleLogin}
          type="button"
          className="mt-8 w-full py-3 border border-[#1A1A1A] flex items-center justify-center gap-3 hover:bg-[#1A1A1A] hover:text-[#FDFBF7] transition-colors text-[11px] uppercase tracking-nav"
          data-testid="login-google"
        >
          <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.9 0 6.6 1.7 8.1 3.1l5.9-5.9C34.5 3.4 29.7 1.5 24 1.5 14.8 1.5 6.9 6.9 3.2 14.7l7 5.4C12.1 14.3 17.6 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-2.8-.4-4.1H24v7.8h12.7c-.3 2.1-1.7 5.2-4.9 7.3l7.6 5.9c4.5-4.2 7.1-10.3 7.1-16.9z"/><path fill="#FBBC05" d="M10.2 28.4c-.5-1.5-.8-3.1-.8-4.9s.3-3.4.8-4.9l-7-5.4C1.6 16.8.5 20.3.5 24s1.1 7.2 2.9 10.3l6.8-5.9z"/><path fill="#34A853" d="M24 46.5c6.5 0 12-2.2 16-5.9l-7.6-5.9c-2.1 1.4-4.9 2.4-8.4 2.4-6.4 0-11.9-4.3-13.8-10.1l-7 5.4c3.7 7.8 11.6 14.1 20.8 14.1z"/></svg>
          Continue with Google
        </button>

        <div className="my-8 flex items-center gap-4">
          <span className="flex-1 h-px bg-[#BCA37F]/40" />
          <span className="text-[10px] uppercase tracking-nav text-[#7A7A7A]">or</span>
          <span className="flex-1 h-px bg-[#BCA37F]/40" />
        </div>

        <form onSubmit={submit} className="space-y-5">
          <label className="block">
            <span className="text-[11px] uppercase tracking-nav text-[#7A7A7A]">Email</span>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="input-underline" data-testid="login-email" />
          </label>
          <label className="block">
            <span className="text-[11px] uppercase tracking-nav text-[#7A7A7A]">Password</span>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="input-underline" data-testid="login-password" />
          </label>
          <button className="btn-editorial w-full" disabled={loading} data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#4A4A4A]">
          New here? <Link to="/signup" className="underline underline-offset-4 hover:text-[#5C1A1B]" data-testid="login-signup-link">Create an account</Link>
        </p>
      </div>
    </main>
  );
}
